import { render, staticRenderFns } from "./new_contacto.vue?vue&type=template&id=6c749b5b&scoped=true"
import script from "./new_contacto.vue?vue&type=script&lang=js"
export * from "./new_contacto.vue?vue&type=script&lang=js"
import style0 from "./new_contacto.vue?vue&type=style&index=0&id=6c749b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c749b5b",
  null
  
)

export default component.exports